import ParkPassAPI from "../parkpassAxiosConfig";


export const listDeletionRequests = async (params = {}) => {
  try {
    const response = await ParkPassAPI.get("/v1/users/delete-requests", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approveDeletionRequest = async (id, payload = {}) => {
  try {
    const response = await ParkPassAPI.post(`/v1/users/delete-requests/${id}/approve`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectDeletionRequest = async (id, payload = {}) => {
  try {
    const response = await ParkPassAPI.post(`/v1/users/delete-requests/${id}/reject`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
